/** @module Specification/PartMaterialColor/PMCColorImageRenderer */
define([
	"dojo/_base/declare",
	"csi/reflection",
	"Apparel/ProductColorImageRenderer"
], function(declare, reflection, ProductColorImageRenderer) {

	return declare(ProductColorImageRenderer, {
		/**
		 * @override
		 * Always render color image using smallest image size
		 */
		reserveContext(ctx, h) {
			ctx.initialImageSize = ctx.prefImageSize;
			ctx.prefImageSize = reflection.IMAGE_SIZE_SMALLEST;
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Restore image size
		 */
		releaseContext(ctx, h) {
			ctx.prefImageSize = ctx.initialImageSize;
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Return referenced color from parent Heading
		 */
		_getStartingColorUrl(ctx, h) {
			return ctx.view.displayColorImages ? ctx.getNodeAttributeValue(h.m_parent.m_id) : null;
		}
	});
});